
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"16","viewBox":"0 0 24 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M1 10a1 1 0 001 1h.378c.424 0 .782.296 1.089.588.269.255.633.412 1.033.412.4 0 .764-.157 1.033-.412.307-.292.665-.588 1.089-.588h9.756c.424 0 .782.296 1.089.588.269.255.633.412 1.033.412.4 0 .764-.157 1.033-.412.307-.292.665-.588 1.089-.588H22a1 1 0 001-1V7.414a1 1 0 00-.293-.707l-2.414-2.414A1 1 0 0019.586 4h-8.253a1 1 0 00-.6.2L7.267 6.8a1 1 0 01-.6.2H5.083a1 1 0 00-.165.014l-2.49.415a1 1 0 00-.668.431l-.592.888A1 1 0 001 9.303V10zm10.363-4.89l-1.25 1a.5.5 0 00.312.89H13.5a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-1.825a.5.5 0 00-.312.11zM15 5.5v1a.5.5 0 00.5.5h1a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-1a.5.5 0 00-.5.5zm3 1v-1a.5.5 0 01.5-.5h.293a.5.5 0 01.353.146l1 1a.5.5 0 01-.353.854H18.5a.5.5 0 01-.5-.5z","fill":"currentColor"}})])
          )
        }
      }
    